import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  BoxExpand,
  Button,
  ButtonsWrapper,
  ICONS,
  PLATFORM_THEME_COLORS,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { AddBankCard } from './components/add-bank-card';
import { PaymentInfoView } from './components/payment-info-view';
import { PaymentsListTable } from './components/payments-list-table';

const PaymentInformation = () => {
  const { t } = useTranslation(['settings', 'common']);
  const [isOpenedChangeCard, setIsOpenedChangeCard] = useState(false);
  const [isViewPaymentHistory, showPaymentHistory] = useState(false);

  const stripeResponse = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

  return (
    <div>
      {isOpenedChangeCard && (
        <Elements stripe={stripeResponse}>
          <AddBankCard onClose={() => setIsOpenedChangeCard(false)} />
        </Elements>
      )}
      <BoxExpand
        title={t(
          `settings:paymentInformation.labels.${
            isViewPaymentHistory ? 'paymentHistory' : 'paymentInformation'
          }`
        )}
        titleFontSize={TYPOGRAPHY_SIZE.medium}
        separator
        buttons={
          <ButtonsWrapper>
            <Button type="primary" ghost onClick={() => showPaymentHistory(!isViewPaymentHistory)}>
              {t(
                `settings:paymentInformation.buttons.${
                  isViewPaymentHistory ? 'showPaymentInformation' : 'showPaymentHistory'
                }`
              )}
            </Button>
            {!isViewPaymentHistory && (
              <Button
                type="primary"
                ghost
                icon={ICONS.revision}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => setIsOpenedChangeCard(true)}
              >
                {t('settings:userProfileSettings.labels.changeCard')}
              </Button>
            )}
          </ButtonsWrapper>
        }
      >
        {isViewPaymentHistory ? <PaymentsListTable /> : <PaymentInfoView />}
      </BoxExpand>
    </div>
  );
};

export default PaymentInformation;
